const PROD_HOST = 'tertius.dcra.dc.gov';
const NEW_PROD_HOST = 'tertius.dob.dc.gov';

export type EnvType = 'local' | 'uat' | 'production';
export const isEnv = (env: EnvType): boolean => {
  if (env === 'local') {
    return window.location.host.includes('localhost');
  }

  if (env === 'uat') {
    return window.location.host.includes('uat');
  }

  if (env === 'production') {
    return window.location.host.includes(PROD_HOST) || window.location.host.includes(NEW_PROD_HOST);
  }

  return false;
};
